import { useEffect, useRef, useState } from "react";
import { Link, useHistory } from "react-router-dom";

function Header() {
  const history = useHistory();

  const [search, setSearch] = useState("");
  const [profileOpen, setProfileOpen] = useState(false);
  const profileRef = useRef(null);

  const token = localStorage.getItem("token");

  const getUserFromToken = () => {
    if (!token) return null;

    try {
      const payload = JSON.parse(atob(token.split(".")[1]));

      return {
        id: payload.id,
        name: payload.name || "",
        username: payload.username || "",
      };
    } catch (error) {
      return null;
    }
  };

  const user = getUserFromToken();

  const displayName =
    user?.name || user?.username || "Իմ պրոֆիլը";

  const handleSearch = (e) => {
    e.preventDefault();

    const value = search.trim();

    if (value) {
      history.push(
        `/products?search=${encodeURIComponent(value)}`
      );
    } else {
      history.push("/products");
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("token");

    // Հին localStorage user data-ի դեպքում նույնպես մաքրում ենք
    localStorage.removeItem("user");

    setProfileOpen(false);

    history.push("/");
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        profileRef.current &&
        !profileRef.current.contains(event.target)
      ) {
        setProfileOpen(false);
      }
    };

    document.addEventListener(
      "mousedown",
      handleClickOutside
    );

    return () => {
      document.removeEventListener(
        "mousedown",
        handleClickOutside
      );
    };
  }, []);

  return (
    <>
      {/* TOP BAR */}
      <div className="top-bar">
        <div className="container top-bar-inner">
          <div className="top-left">
            <Link to="/">Գլխավոր</Link>

            <Link to="/products">
              Հայտարարություններ
            </Link>

            <Link to="/create-listing">
              Վաճառել
            </Link>
          </div>

          <div className="top-right">
            <span>📍 Երևան</span>

            <Link to="/my-listings">
              Իմ հայտարարությունները
            </Link>

            <Link to="/my-messages">
              💬 Հաղորդագրություններ
            </Link>
          </div>
        </div>
      </div>

      {/* MAIN HEADER */}
      <header className="main-header">
        <div className="container main-header-inner">

          {/* LOGO */}
          <Link to="/" className="main-logo">
            <span className="logo-icon">B</span>

            <span>
              Առք <span>և</span> Վաճառք
            </span>
          </Link>

          {/* CATEGORIES */}
          <Link
            to="/products"
            className="categories-button"
          >
            <span className="menu-icon">☰</span>
            <span>Կատեգորիաներ</span>
          </Link>

          {/* SEARCH */}
          <form
            className="header-search"
            onSubmit={handleSearch}
          >
            <span>⌕</span>

            <input
              type="text"
              value={search}
              onChange={(e) =>
                setSearch(e.target.value)
              }
              placeholder="Ի՞նչ եք փնտրում..."
            />

            <button type="submit">
              Որոնել
            </button>
          </form>

          {/* ACTIONS */}
          <div className="header-actions">

            {/* FAVORITES */}
            <button
              type="button"
              className="header-action"
              title="Ընտրյալներ"
              onClick={() =>
                history.push("/favorites")
              }
            >
              <span>♡</span>
            </button>

            {/* ADD LISTING */}
            <Link
              to="/create-listing"
              className="header-action"
              title="Տեղադրել հայտարարություն"
            >
              <span>＋</span>
            </Link>

            {/* PROFILE / LOGIN */}
            {token && user ? (
              <div
                className="profile-wrapper"
                ref={profileRef}
              >
                <button
                  type="button"
                  className="profile-button"
                  onClick={() =>
                    setProfileOpen(!profileOpen)
                  }
                >
                  <span className="profile-avatar">
                    {displayName
                      .charAt(0)
                      .toUpperCase()}
                  </span>

                  <span className="profile-name">
                    {displayName}
                  </span>

                  <span
                    className={`profile-arrow ${
                      profileOpen ? "open" : ""
                    }`}
                  >
                    ▾
                  </span>
                </button>

                {/* DROPDOWN */}
                {profileOpen && (
                  <div className="profile-dropdown">

                    <div className="profile-dropdown-header">
                      <div className="profile-avatar large">
                        {displayName
                          .charAt(0)
                          .toUpperCase()}
                      </div>

                      <div>
                        <strong>
                          {displayName}
                        </strong>

                        {user.username && (
                          <small>
                            @{user.username}
                          </small>
                        )}
                      </div>
                    </div>

                    <div className="profile-divider" />

                    <Link
                      to="/profile"
                      className="profile-menu-item"
                      onClick={() =>
                        setProfileOpen(false)
                      }
                    >
                      <span>👤</span>
                      <span>Իմ պրոֆիլը</span>
                    </Link>

                    <Link
                      to="/my-listings"
                      className="profile-menu-item"
                      onClick={() =>
                        setProfileOpen(false)
                      }
                    >
                      <span>📋</span>
                      <span>
                        Իմ հայտարարությունները
                      </span>
                    </Link>

                    <Link
                      to="/my-messages"
                      className="profile-menu-item"
                      onClick={() =>
                        setProfileOpen(false)
                      }
                    >
                      <span>💬</span>
                      <span>Հաղորդագրություններ</span>
                    </Link>

                    <Link
                      to="/change-password"
                      className="profile-menu-item"
                      onClick={() =>
                        setProfileOpen(false)
                      }
                    >
                      <span>🔐</span>
                      <span>Փոխել գաղտնաբառը</span>
                    </Link>

                    <div className="profile-divider" />

                    <button
                      type="button"
                      className="profile-menu-item logout"
                      onClick={handleLogout}
                    >
                      <span>🚪</span>
                      <span>Ելք</span>
                    </button>

                  </div>
                )}
              </div>
            ) : (
              <Link
                to="/login"
                className="login-button"
              >
                <span>♙</span>
                <span>Մուտք գործել</span>
              </Link>
            )}

          </div>
        </div>
      </header>
    </>
  );
}

export default Header;